/**
 * Create safer type guards: https://unsplash.com/blog/user-defined-type-guards-not-safe/
 *
 * ```ts
 * const isNumber = typeGuard(
 *     (n) => typeof n === 'number' ? n : undefined
 * ); // Ensure that n is number
 *
 * const isBurger = typeGuard(
 *     (food) => food._tag === 'Burger' ? food : undefined
 * ); // Differentiate a discriminated union
 * ```
 *
 * In `Array.filter()`:
 * ```ts
 * const booleanOrNumber: (boolean, undefined)[] = [true, false, 1, true, 0];
 * const onlyBoolean: boolean[] = booleanOrUndefined.filter(typeGuard(
 *     (b) => typeof b === 'boolean' ? b : undefined
 * )) // [true, false, true]
 * ```
 */
export const typeGuard = <A, B extends A>(fn: (a: A) => B | undefined) => {
    return (a: A): a is B => typeof fn(a) !== 'undefined';
};
